<template>
	<div class="brand_box">
		<div class="brand_title">
			保护&nbsp;<i class="el-icon-right"></i>
		</div>
		<dv-border-box-8>
			<div class="barCart">
				<div class="brandCase_box">
					<div class="brandCase">
						<div class="brandCase_title">案件总值</div>
						<div class="brandCase_num">
							<span>{{obj.tmtort}}</span>件
						</div>
					</div>
					<div id="protectChart1" style="width:85%;height:1.2rem;margin-bottom:0.2rem;"></div>
				</div>
				<div class="caseValue_box">
					<div class="caseValue">
						<div class="caseValue_title">罚没金额</div>
						<div class="caseValue_num">
							<span>{{Math.round(obj.tmtortmoney)}}</span>万元
						</div>
					</div>
					<div id="protectChart2" style="width:85%;height:1.2rem;"></div>
				</div>
			</div>
		</dv-border-box-8>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				obj:{},
			}
		},
		mounted() {},
		methods:{
			getData(data,list){
				this.obj = data
				this.drawCart5(list);
				this.drawCart6(list);
			},
			// 保护
			drawCart5(list) {
				let myChart = this.$echarts.init(document.getElementById('protectChart1'));
				var option = {
					textStyle: {
						color: '#fff',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: '#FF0000'
							}
						}
					},
					grid: {
						left: '0',
						right: '0',
						top: '20%',
						bottom: '0',
						containLabel: true
					},
					legend: {
						data: ["案件总值"],
						right: 0,
						top: 0,
						textStyle: {
							color: "#fff"
						},
						itemWidth: 10,
						itemHeight: 10,
					},
					color: ['#3999F3'],
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.city),
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					series: [{
						name: '案件总值',
						type: 'bar',
						itemStyle: '',
						barWidth: '55%', //柱子粗细
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						data:list.map(item =>item.tmtort),
					}]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			// 保护-柱状图
			drawCart6(list) {
				let myChart = this.$echarts.init(document.getElementById('protectChart2'));
				for(var i in list){
					list[i].tmtortmoney = list[i].tmtortmoney.toFixed(1)
				}
				var option = {
					textStyle: {
						color: '#fff',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					grid: {
						left: '0',
						right: '0',
						top: '25%',
						bottom: '0',
						containLabel: true
					},
					legend: {
						data: ["罚没金额(万元)"],
						right: 0,
						top: 0,
						textStyle: {
							color: "#fff"
						},
						itemWidth: 10,
						itemHeight: 10,
					},
					color: ['#3853DE'],
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.city),
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					series: [{
						name: '罚没金额(万元)',
						type: 'bar',
						itemStyle: '',
						barWidth: '55%', //柱子粗细
						label: { //显示数值
							show: true,
							position: 'outside',
							color: '#fff'
						},
						data:list.map(item =>item.tmtortmoney),
					}]
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>
